import React from 'react';
import { useLocation } from 'react-router-dom';

import ShipmentsGridPlaceholder from './shipments-grid';
import BatchesGridPlaceholder from './batches-grid';
import { BATCHES_VIEW_ID } from '../../../components/shipping-grid/views/view-id-constants';

const GridPlaceholder = () => {
  const location = useLocation();

  const isOnBatchesGrid = location?.pathname?.includes(BATCHES_VIEW_ID);

  return isOnBatchesGrid ? <BatchesGridPlaceholder location={location} /> : <ShipmentsGridPlaceholder />;
};

export default GridPlaceholder;
